import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import SoFormAddresses from './blocks/addresses/SoFormAddresses';
import SoFormLoads from './blocks/loads/SoFormLoads';
import SoFormVehicleDetails from './blocks/vehicleDetails/SoFormVehicleDetails';
import SoFormContainer from '../../components/layout/SoFormContainer';
import SoRecurringCheckbox from './SoRecurringCheckbox';

const SoFormStepConfigurationBody = ({ className }) => (
  <div className={className}>
    <SoFormContainer>
      <SoRecurringCheckbox />
      <SoFormAddresses />
      <SoFormLoads />
      <SoFormVehicleDetails />
    </SoFormContainer>
  </div>
);

SoFormStepConfigurationBody.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepConfigurationBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 0px;
  width: 100%;
  ${SoFormContainer} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0px;
    gap: 16px;
    padding: 0;
  }
  flex-grow: 1;
`;
